/**
 * @generated SignedSource<<923773bf936d7e3902fa4d4618587fe6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addressSggQuery$variables = {
  sidoNm?: string | null | undefined;
};
export type addressSggQuery$data = {
  readonly getSurveyAddress: ReadonlyArray<{
    readonly sggNm: string | null | undefined;
  }>;
};
export type addressSggQuery = {
  response: addressSggQuery$data;
  variables: addressSggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sidoNm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sidoNm",
        "variableName": "sidoNm"
      }
    ],
    "concreteType": "RefundUserGetSurveyAddressOutput",
    "kind": "LinkedField",
    "name": "getSurveyAddress",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sggNm",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addressSggQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addressSggQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef098ac74ca65bebdfc03166716c3f7d",
    "id": null,
    "metadata": {},
    "name": "addressSggQuery",
    "operationKind": "query",
    "text": "query addressSggQuery(\n  $sidoNm: String\n) {\n  getSurveyAddress(sidoNm: $sidoNm) {\n    sggNm\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9307a690b18472b7e3794a8cdd883e4";

export default node;
